module.exports = __webpack_public_path__ + "img/ssl.4088d48f.png";